import { Component, OnInit } from '@angular/core';
import { ErrorHandler } from '../utils/error-handler';
import { MessagesService } from '../messages/messages.service';
import { Covid19Batch } from '../agptesting-newview/model/covid19Batch';
import { MergeRequest } from './merge-request';
import { MasterDataService } from '../masterdata/masterdata.service';
import { SelectItem } from 'primeng/api';
import { MidplexMergeService } from './midplex-merge.service';
@Component({
  selector: 'app-midplex-merge',
  templateUrl: './midplex-merge.component.html',
  styleUrls: ['./midplex-merge.component.css']
})
export class MidplexMergeComponent implements OnInit {

  mergedBatch: Covid19Batch;
  batches: Covid19Batch[] = [];
  selectedBatch: Covid19Batch[] = [];
  singleSelectedBatch: Covid19Batch[] = [];
  a1BatchCode: string;
  a2BatchCode: string;
  b1BatchCode: string;
  b2BatchCode: string;
  errorHandler: ErrorHandler = new ErrorHandler;
  user: string;
  mergeBatchId: string;
  selectedLabId: string;
  dateFormat:string;
  submitted = false;
  allowA1: boolean = true;
  allowA2: boolean = true;
  allowB1: boolean = true;
  allowB2: boolean = true;
  count: number = 0;
  mergeGroupList: SelectItem[] = [];
  displayBatches: Covid19Batch[] = [];
  mergedBatchList: string[] = [];
  mapofMergeGroup = new Map();
  workFlows: any[] = [];
  workFlowsList: any[] = [];
  mergeBatchList: string[] = [];
  a1MergeBatchCode: string = "";
  a2MergeBatchCode: string = "";
  b1MergeBatchCode: string = "";
  b2MergeBatchCode: string = "";
  blocked: boolean = false;
  loading: boolean = false;
  displayLoading: boolean = false;
  mapOfMergedBatches: Map<any, any> = new Map();
  mergeSelectedBatch: Covid19Batch;
  mapofWorkflowMergeInStatus = new Map();
  mapofMergeInStatusActualStatus = new Map();
  selectedWorkflow:string;
  productList:any[] = [];
  valueToSearchforProduct: any[] = [];
  isExist: boolean = false;

  constructor(private _messagesService: MessagesService, 
    private midplexMergeService: MidplexMergeService, private masterDataService: MasterDataService) { }

  ngOnInit() {
    let lab= JSON.parse(localStorage.getItem('lab'))
    this.selectedLabId = lab.lab._id;
    this.dateFormat =this.setDateFormat(lab.lab.dateFormat.toLowerCase());
    this.user = localStorage.getItem('PUID');
    this.selectedBatch = [];
    this.getMergedBatches();
    this.getActiveWorkFlows();
  }
  setDateFormat(dateFormat){
    return   dateFormat.length>8  ? dateFormat.replace("yyyy","yy"): dateFormat.replace("yy","y");
  }

  getActiveWorkFlows() {
    this.blocked = true;
    this.workFlows = [];
    this.masterDataService.getActiveWorkFlowsByLabWorkflowGroup(JSON.parse(localStorage.getItem('lab')).lab, "Midplex", "WELL384").subscribe(
      results=>{
        if(results.data && results.data.data && results.data.data.length > 0){
          results.data.data.forEach(workFlow => {
              this.mapofWorkflowMergeInStatus.set(workFlow.workFlowName,workFlow.mergeInStatus);
              this.workFlows.push({label:workFlow.workFlowName, value:workFlow.workFlowName});
              if(workFlow.mergeInStatus === 'CONTROLS ADDED'){
                this.mapofMergeInStatusActualStatus.set(workFlow.mergeInStatus,"CONTROLS_ADDED");
              }
          });
          this.selectedWorkflow = results.data.data[0].workFlowName;
          this.getActiveProductByWorkFlow();
        }
        this.blocked = false;
      },
      error=>{
       this.handleError(error);
      }
    )
  }
  regexMatcher(regex: string, value: string): boolean {
    let regexp = new RegExp(regex);
    return regexp.test(value);
  }
  onSubmit() {
    if (!this.regexMatcher("^(?!_)[a-zA-Z0-9_]*$", this.mergeBatchId)) {
      this._messagesService.addErrorMessage({
        severity: 'error', summary:'Invalid BatchID!',
        detail:'Please enter Valid BatchId For Merged Batch'
      });
      return;
    }
    this.submitted = true;
    let mergeRequest = new MergeRequest();
    mergeRequest.labId = this.selectedLabId;
    mergeRequest.mergedBatchId = this.mergeBatchId;
    let sourceBatchIds: string[] = [];
    let sourceMap = new Map<string, string>();

    if (this.a1BatchCode) {
      sourceMap.set(this.a1BatchCode, 'A1');
      sourceBatchIds.push(this.a1BatchCode);
    }
    if (this.a2BatchCode) {
      sourceMap.set(this.a2BatchCode, 'A2');
      sourceBatchIds.push(this.a2BatchCode);
    }
    if (this.b1BatchCode) {
      sourceMap.set(this.b1BatchCode, 'B1');
      sourceBatchIds.push(this.b1BatchCode);
    }
    if (this.b2BatchCode) {
      sourceMap.set(this.b2BatchCode, 'B2');
      sourceBatchIds.push(this.b2BatchCode);
    }

    let sourceJsonMap = {};
    sourceMap.forEach((V, K) => {
      sourceJsonMap[K] = V;
    });
    mergeRequest.sourceBatchIds = sourceBatchIds;
    mergeRequest.pcrPlateID = this.mergeBatchId;
    mergeRequest.sourceBatchIdMap = sourceJsonMap;
    mergeRequest.workflowGroup = 'Midplex';
    mergeRequest.tagSystemName = this.selectedBatch[0].tagSystemName;
    mergeRequest.product = this.selectedBatch[0].product;
    mergeRequest.userID = this.user;
    this.blocked = true;
    this.midplexMergeService.mergeBatch(mergeRequest).subscribe(
      results => {
        this._messagesService.addSuccessMessage({
          severity: 'success', summary: 'Batch Created!',
          detail: 'Batch ' + results.data.batchID + ' has been created for user ' + this.user
        })
        this.blocked = false;
        this.mergedBatch = results.data;
        this.mergeBatchId = null;
        this.getMergedBatches();
        this.filterBatchStatus();
      },
      error => {
        this.handleError(error);
      })
  }

  private handleError(error: any) {
    this.blocked = false;
    let message = this.errorHandler.handleError(error);
    this._messagesService.addErrorMessage(message);
  }

  filterBatchStatus() {
    this.selectedBatch = [];
    this.clearBatchcodes();
    this.singleSelectedBatch = [];
    this.displayBatches = [];
    this.setAllowStatus();
    this.displayLoading = true;let mergeInStatus = this.mapofWorkflowMergeInStatus.get(this.selectedWorkflow);
    let actualStatus = this.mapofMergeInStatusActualStatus.get(mergeInStatus);
    this.midplexMergeService.getBatches(this.selectedLabId, "Midplex", actualStatus, this.valueToSearchforProduct).subscribe(
      results => {
        this.batches = results.data;
        if (this.batches && this.batches.length > 0)
          this.displayBatches = [...this.batches];
        this.displayLoading = false;
      },
      error => {
        this.displayLoading = false;
        let message = this.errorHandler.handleError(error);
        this._messagesService.addErrorMessage(message);
      }
    )
  }

  onRowUnselect(event) {
    this.singleSelectedBatch = this.singleSelectedBatch.filter(obj => obj !== event.data)
    this.selectedBatch = [];
    this.clearBatchcodes();
    for (let singleBatch of this.singleSelectedBatch) {
      if (this.allowA1 && this.a1BatchCode == "") {
        this.a1BatchCode = singleBatch.batchID;
        this.selectedBatch[0] = singleBatch;
      }
      else if (this.allowA2 && this.a2BatchCode == "") {
        this.selectedBatch[1] = singleBatch;
        this.a2BatchCode = singleBatch.batchID;
      }
      else if (this.allowB1 && this.b1BatchCode == "") {
        this.selectedBatch[2] = singleBatch;
        this.b1BatchCode = singleBatch.batchID;
      }
      else if (this.allowB2 && this.b2BatchCode == "") {
        this.selectedBatch[3] = singleBatch;
        this.b2BatchCode = singleBatch.batchID;
      }
    }
  }

  onRowSelect(event) {

    let len = this.singleSelectedBatch.length - 1;
    if (this.allowA1 && this.a1BatchCode == "") {
      this.a1BatchCode = this.singleSelectedBatch[len].batchID;
      this.selectedBatch[0] = this.singleSelectedBatch[len];
    }
    else if (this.allowA2 && this.a2BatchCode == "") {
      this.selectedBatch[1] = this.singleSelectedBatch[len];
      this.a2BatchCode = this.singleSelectedBatch[len].batchID;
    }
    else if (this.allowB1 && this.b1BatchCode == "") {
      this.selectedBatch[2] = this.singleSelectedBatch[len];
      this.b1BatchCode = this.singleSelectedBatch[len].batchID;
    }
    else if (this.allowB2 && this.b2BatchCode == "") {
      this.selectedBatch[3] = this.singleSelectedBatch[len];
      this.b2BatchCode = this.singleSelectedBatch[len].batchID;
    }
    if (this.singleSelectedBatch.length == this.mergeCount() + 1) {
      this.singleSelectedBatch.splice(this.count, 1)
    }
  }
  mergeCount() {
    this.count = 0;
    if (this.allowA1) {
      this.count++;
    }
    if (this.allowA2) {
      this.count++;
    }
    if (this.allowB1) {
      this.count++;
    }
    if (this.allowB2) {
      this.count++;
    }
    return this.count;
  }


  clearBatchcodes() {
    this.a1BatchCode = "";
    this.a2BatchCode = "";
    this.b1BatchCode = "";
    this.b2BatchCode = "";
  }
  clearMergeBatchcodes() {
    this.a1MergeBatchCode = "";
    this.a2MergeBatchCode = "";
    this.b1MergeBatchCode = "";
    this.b2MergeBatchCode = "";
  }
  isMergeOk() {
    return !(this.a1BatchCode != "" || this.a2BatchCode != "" || this.b1BatchCode != "" || this.b2BatchCode != "")
  }
  setAllowStatus() {
    this.allowA1 = true;
    this.allowA2 = true;
    this.allowB1 = true;
    this.allowB2 = true;
  }

  onSelectedBatchDelete(batch: string) {
    var data: Covid19Batch[] = [];
    this.clearBatchcodes();

    for (let singleBatch of this.singleSelectedBatch) {
      if (singleBatch.batchID !== batch) {
        data.push(singleBatch);
        if (this.allowA1 && this.a1BatchCode == "") {
          this.a1BatchCode = singleBatch.batchID;
          this.selectedBatch[0] = singleBatch;
        }
        else if (this.allowA2 && this.a2BatchCode == "") {
          this.selectedBatch[1] = singleBatch;
          this.a2BatchCode = singleBatch.batchID;
        }
        else if (this.allowB1 && this.b1BatchCode == "") {
          this.selectedBatch[2] = singleBatch;
          this.b1BatchCode = singleBatch.batchID;
        }
        else if (this.allowB2 && this.b2BatchCode == "") {
          this.selectedBatch[3] = singleBatch;
          this.b2BatchCode = singleBatch.batchID;
        }
      }
    }
    this.singleSelectedBatch = data;
  }

  undoMerge() {
    let mergeRequest = new MergeRequest();
    mergeRequest.labId = this.selectedLabId;
    let selectedBatch = this.mapOfMergedBatches.get(this.mergeSelectedBatch)
    mergeRequest.mergedBatchId = selectedBatch.batchID;
    const sourceJsonMap: Map<string, object> = new Map();

    Object.entries(selectedBatch.mergedBatches).forEach(([K, V]) => {
      let value = new Object(V); 
      sourceJsonMap.set(K, value);

    });
    mergeRequest.sourceBatchIds = selectedBatch.sourceBatchIds;
    mergeRequest.sourceBatchIdMap = sourceJsonMap;
    this.blocked = true;
    this.midplexMergeService.undoMerge(mergeRequest).subscribe(
      results => {
        this._messagesService.addSuccessMessage({
          severity: 'success', summary: 'Undo Merge Successfull!',
          detail: 'Undo merge for the Batch ' + selectedBatch.batchID + ' has been done by the user '
            + this.user + ' successfully!'
        })
        this.blocked = false;
        this.mergeSelectedBatch = null;
        this.getMergedBatches();
        this.filterBatchStatus();
      },
      error => {
        this.handleError(error);
      })

  }

  batchStatus() {

    return !(this.mergedBatch && 'MERGE_DEFINED' === this.mergedBatch.statusOfTheBatch);

  }

  getMergedBatches() {
    this.loading = true;
    this.midplexMergeService.getAllMergedDefinedBatces(this.selectedLabId).subscribe(
      result => {
          this.mergedBatchList = [];
          if(result.data){
            this.mapOfMergedBatches = new Map(Object.entries(result.data));
            this.mergedBatchList = Array.from(this.mapOfMergedBatches.keys());
          } else{
            this.mapOfMergedBatches = new Map();
          }
          this.loading = false;
      },
      error => {
        this.loading = false;
        let message = this.errorHandler.handleError(error);
        this._messagesService.addErrorMessage(message);
      }

    )
  }

  completeMerge(){
    let selectedMergedBatch = this.mapOfMergedBatches.get(this.mergeSelectedBatch)
    selectedMergedBatch.mergeCompletePUID=this.user;
    selectedMergedBatch.statusOfTheBatch96 = 'MERGED';
    selectedMergedBatch.statusOfTheBatch384 = 'MERGE_COMPLETE';
    this.blocked = true;
    this.midplexMergeService.completeMergeProcess(selectedMergedBatch, this.selectedLabId).subscribe(
      result=>{
        this._messagesService.addSuccessMessage({
          severity: 'success', summary: 'Completed Merge!!',
          detail: 'Merge Batch Completion Successfull!'
        })
        this.blocked = false;
        this.getMergedBatches();
        this.filterBatchStatus();
      },
      error=>{
        this.handleError(error); 
      }
    )
  }

  getActiveProductByWorkFlow() {
    this.blocked = true;
    this.productList = [];
    let names = [];
    this.valueToSearchforProduct = [];
    this.masterDataService.getProductsByWorkflow(JSON.parse(localStorage.getItem('lab')).lab._id, this.selectedWorkflow).subscribe(
      results=>{
        if(results.data && results.data.data && results.data.data.length > 0){
          results.data.data.forEach(product => {
            this.productList.push({label:product.name, value:product.name});
            names.push(product.name);
          });
        }
        this.valueToSearchforProduct = names;
        if(this.valueToSearchforProduct && this.valueToSearchforProduct.length > 0){
          this.filterBatchStatus();
        } else {
          this.displayBatches = [];
        }
        this.blocked = false;
      },
      error=>{
       this.handleError(error);
      }
    )
  }

  onWorkflowChange(){
    this.getActiveProductByWorkFlow();
  }

  onApplyFilter(data:any){
    if(!this.valueToSearchforProduct || (this.valueToSearchforProduct && this.valueToSearchforProduct.length==0)){
      this.selectedBatch = [];
      this.clearBatchcodes();
      this.singleSelectedBatch = [];
      this.displayBatches = [];
      this.setAllowStatus();
      this.mergeBatchId = "";
    }else{
      this.filterBatchStatus();
    }
  }

  checkBatchExistance(batchId : string){
    if(batchId){
      this.blocked=true;
      this.midplexMergeService.getBatchForLabAndBatchId(this.selectedLabId, "BatchId", batchId).subscribe(
        result => {
          if (result.data) {
            this._messagesService.addWarningMessage({ 
              severity: 'warn', summary: 'Batch Exists', 
              detail: 'The batch '+batchId+' for the new batch exists already. Please chose a different batch ID.'});
              this.isExist = true;
          } else {
            this.isExist = false;
          }
          
          this.blocked=false;
        },
        error => {
          this.handleError(error);
        }
      );
    }
  }
}
